module.exports = __webpack_public_path__ + "img/cave20.36ee6cc6.jpg";